import config from "../config.ts";

const DEFAULT_WIDGET_AUTH_BASE_URL =
  process.env.NEXTAUTH_URL ||
  process.env.NEXT_PUBLIC_APP_URL ||
  `https://${config.domainName}`;

const normalizeBaseUrl = (value: string) => value.replace(/\/$/, "");

const splitHost = (value: string) => {
  const [hostname = "", port = ""] = value.trim().toLowerCase().split(":");

  return {
    hostname,
    port,
  };
};

export const resolveStableWidgetAuthBaseUrl = (
  currentHost: string,
  fallbackBaseUrl = DEFAULT_WIDGET_AUTH_BASE_URL
) => {
  const normalizedFallbackBaseUrl = normalizeBaseUrl(fallbackBaseUrl);
  const { hostname, port } = splitHost(currentHost);
  const normalizedPort = port ? `:${port}` : "";

  if (!hostname) {
    return normalizedFallbackBaseUrl;
  }

  if (
    hostname === "localhost" ||
    hostname.endsWith(".localhost")
  ) {
    return `http://localhost${normalizedPort}`;
  }

  if (
    hostname === "127.0.0.1" ||
    hostname.endsWith(".127.0.0.1")
  ) {
    return `http://127.0.0.1${normalizedPort}`;
  }

  if (
    hostname === config.domainName ||
    hostname === `www.${config.domainName}` ||
    hostname.endsWith(`.${config.domainName}`)
  ) {
    return `https://${config.domainName}`;
  }

  return normalizedFallbackBaseUrl;
};

export const resolveWidgetAuthBaseUrlFromHeaders = (
  headers: Headers,
  fallbackBaseUrl = DEFAULT_WIDGET_AUTH_BASE_URL
) => {
  const forwardedHost = headers.get("x-forwarded-host")?.trim();
  const host = forwardedHost || headers.get("host")?.trim() || "";

  return resolveStableWidgetAuthBaseUrl(host, fallbackBaseUrl);
};

export const resolveWidgetAuthBaseUrl = (
  requestUrl: string,
  fallbackBaseUrl = DEFAULT_WIDGET_AUTH_BASE_URL
) => {
  try {
    return resolveStableWidgetAuthBaseUrl(new URL(requestUrl).host, fallbackBaseUrl);
  } catch {
    return normalizeBaseUrl(fallbackBaseUrl);
  }
};
